// ** Vertical Menu Components
import VerticalNavMenuLink from './VerticalNavMenuLink'
import VerticalNavMenuGroup from './VerticalNavMenuGroup'
import VerticalNavMenuSectionHeader from './VerticalNavMenuSectionHeader'

// ** Utils
import { canViewMenuGroup, resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@layouts/utils'
import { Badge } from 'reactstrap'
import { useSelector } from 'react-redux'

const VerticalMenuNavItems = (props) => {
	// ** Components Object
	const Components = {
		VerticalNavMenuLink,
		VerticalNavMenuGroup,
		VerticalNavMenuSectionHeader
	}

	const first_charge = useSelector((state) => state.event.itemcharge?.data)
	const first_info = useSelector((state) => state.event.chargeinfo?.data)
	const daily_charge = useSelector((state) => state.event.itemdailycharge?.data)
	const daily_info = useSelector((state) => state.event.chargedailyinfo?.data)
	const money_charge = useSelector((state) => state.event.itemmoneycharge?.data)
	const money_info = useSelector((state) => state.event.chargemoneyinfo?.data)
	const month_charge = useSelector((state) => state.event.itemmonthcharge?.data)
	const month_info = useSelector((state) => state.event.chargemonthinfo?.data)
	const year_charge = useSelector((state) => state.event.itemyearcharge?.data)
	const year_info = useSelector((state) => state.event.chargeyearinfo?.data)
	const award_unreceive = useSelector((state) => state.event.award.data?.itemUnreceiveCount)
	const config_card = useSelector((state) => state.config.card?.data)

	const promoCheck = () => {
		const today = new Date()
		const promoBegin = new Date(config_card?.promoBegin)
		const promoEnd = new Date(config_card?.promoEnd)

		if (today >= promoBegin && today <= promoEnd) {
			return true
		} else {
			return false
		}
	}

	const promo = () => {
		const today = new Date()
		const promoBegin = new Date(config_card?.promoBegin)
		const promoEnd = new Date(config_card?.promoEnd)

		if (today >= promoBegin && today <= promoEnd) {
			return (
				<Badge color="danger" style={{ marginLeft: '-8px', fontSize: '7px', padding: '3px 6px' }} pill>
					KM
				</Badge>
			)
		} else {
			return null
		}
	}

	const calculateChargeKeys = (charge, info) => {
		if (charge && typeof charge === 'object' && info && typeof info === 'object') {
			const chargeKeys = Object.keys(charge)
			const matchingKeys = chargeKeys.filter((key) => {
				const chargeValue = parseInt(key)
				const hasMatchingCard = info.receive.some((item) => item.firstcard === chargeValue)
				const hasMatchingResetAll = info.receive.some((item) => item.reset_all === chargeValue)
				return info.count >= chargeValue && !(hasMatchingCard || hasMatchingResetAll)
			})

			return matchingKeys.length
		}

		return 0
	}

	let eventCharge = 0

	eventCharge += calculateChargeKeys(first_charge, first_info)
	eventCharge += calculateChargeKeys(daily_charge, daily_info)
	eventCharge += calculateChargeKeys(money_charge, money_info)
	eventCharge += calculateChargeKeys(month_charge, month_info)
	eventCharge += calculateChargeKeys(year_charge, year_info)

	// ** Render Nav Menu Items
	const RenderNavItems = props.items.map((item, index) => {
		let TagName = Components[resolveNavItemComponent(item)] // Declare and initialize the TagName variable

		if (item.id === 'event-charge') {
			if (item.children) {
				return (
					canViewMenuGroup(item) && (
						<>
							{eventCharge !== 0 ? (
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<TagName key={item.id || item.header} item={item} {...props} />
									<Badge color="danger" style={{ marginLeft: '-10px', fontSize: '8px', padding: '3px 6px' }} pill>
										{eventCharge}
									</Badge>
								</div>
							) : (
								<TagName key={item.id || item.header} item={item} {...props} />
							)}
						</>
					)
				)
			}
			return (
				item && (
					<>
						{eventCharge !== 0 ? (
							<div style={{ display: 'flex', alignItems: 'center', marginTop: '-7px' }}>
								<TagName key={item.id || item.header} item={item} {...props} />
								<Badge color="danger" style={{ marginLeft: '-10px', fontSize: '8px', padding: '3px 6px' }} pill>
									{eventCharge}
								</Badge>
							</div>
						) : (
							<TagName key={item.id || item.header} item={item} {...props} />
						)}
					</>
				)
			)
		}

		if (item.id === 'event-get') {
			if (item.children) {
				return (
					canViewMenuGroup(item) && (
						<>
							{award_unreceive !== 0 ? (
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<TagName key={item.id || item.header} item={item} {...props} />
									<Badge color="danger" style={{ marginLeft: '-10px', fontSize: '8px', padding: '3px 6px' }} pill>
										{award_unreceive}
									</Badge>
								</div>
							) : (
								<TagName key={item.id || item.header} item={item} {...props} />
							)}
						</>
					)
				)
			}
			return (
				item && (
					<>
						{award_unreceive !== 0 ? (
							<div style={{ display: 'flex', alignItems: 'center', marginTop: '-7px' }}>
								<TagName key={item.id || item.header} item={item} {...props} />
								<Badge color="danger" style={{ marginLeft: '-10px', fontSize: '8px', padding: '3px 6px' }} pill>
									{award_unreceive}
								</Badge>
							</div>
						) : (
							<TagName key={item.id || item.header} item={item} {...props} />
						)}
					</>
				)
			)
		}

		if (item.id === 'payment-atm') {
			if (item.children) {
				return (
					canViewMenuGroup(item) && (
						<>
							{promoCheck ? (
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<TagName key={item.id || item.header} item={item} {...props} />
									{promo()}
								</div>
							) : (
								<TagName key={item.id || item.header} item={item} {...props} />
							)}
						</>
					)
				)
			}
			return (
				item && (
					<>
						{promoCheck ? (
							<div style={{ display: 'flex', alignItems: 'center', marginTop: '-7px' }}>
								<TagName key={item.id || item.header} item={item} {...props} />
								{promo()}
							</div>
						) : (
							<TagName key={item.id || item.header} item={item} {...props} />
						)}
					</>
				)
			)
		}

		if (item.id === 'payment-card') {
			if (item.children) {
				return (
					canViewMenuGroup(item) && (
						<>
							{promoCheck ? (
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<TagName key={item.id || item.header} item={item} {...props} />
									{promo()}
								</div>
							) : (
								<TagName key={item.id || item.header} item={item} {...props} />
							)}
						</>
					)
				)
			}
			return (
				item && (
					<>
						{promoCheck ? (
							<div style={{ display: 'flex', alignItems: 'center', marginTop: '-7px' }}>
								<TagName key={item.id || item.header} item={item} {...props} />
								{promo()}
							</div>
						) : (
							<TagName key={item.id || item.header} item={item} {...props} />
						)}
					</>
				)
			)
		}

		if (item.children) {
			return canViewMenuGroup(item) && <TagName key={item.id || item.header} item={item} {...props} />
		}

		return item && <TagName key={item.id || item.header} item={item} {...props} />
	})

	return RenderNavItems
}

export default VerticalMenuNavItems
